export default __webpack_public_path__ + "media/icons/Team@2x-ea26f092.svg";